export enum BookingTypeEnum {
  MANUAL_BOOK = 'MANUAL_BOOK',
  AUTO_BOOK_WITH_FIRST_ANSWER = 'AUTO_BOOK_WITH_FIRST_ANSWER',
  AUTO_BOOK_WITH_CHEAPEST = 'AUTO_BOOK_WITH_CHEAPEST',
  AUTO_BOOK_IN_ORDER = 'AUTO_BOOK_IN_ORDER',
  SEARCH_BOOK = 'SEARCH_BOOK',
  INTERLINE_BOOK = 'INTERLINE_BOOK',
  QUANTUM_QUOTE = 'QUANTUM_QUOTE',
}
